// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.control-overview {
  border-radius: var(--ui-radius-xl);
}

.overview-metrics-grid {
  gap: var(--ui-space-3);
}

.overview-section-toggle {
  width: 100%;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  background: var(--ui-surface-soft);
  color: var(--ui-text);
  padding: 0.62rem 0.82rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  cursor: pointer;
}

.overview-metric-card {
  min-height: 132px;
}

.overview-table {
  min-width: 680px;
}

@media (max-width: 960px) {
  .control-overview {
    padding: var(--ui-space-4);
  }

  .overview-table-wrap {
    overflow-x: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/views-overview.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,qBAAqB;EACrB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".control-overview {\n  border-radius: var(--ui-radius-xl);\n}\n\n.overview-metrics-grid {\n  gap: var(--ui-space-3);\n}\n\n.overview-section-toggle {\n  width: 100%;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  background: var(--ui-surface-soft);\n  color: var(--ui-text);\n  padding: 0.62rem 0.82rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.overview-metric-card {\n  min-height: 132px;\n}\n\n.overview-table {\n  min-width: 680px;\n}\n\n@media (max-width: 960px) {\n  .control-overview {\n    padding: var(--ui-space-4);\n  }\n\n  .overview-table-wrap {\n    overflow-x: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
